// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1HUgu","dragIcon":"Choice_dragIcon__36_EZ","left":"Choice_left__19m-t","input":"Choice_input__33jrZ"};